import { Component, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { DashboardComponent } from '../../components/dashboard/dashboard.component';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { forkJoin } from 'rxjs';
import { DashboardConfig } from '../../components/dashboard/dashboard.types';
import { SettingsService } from '../../services/settings.service';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [CommonModule, DashboardComponent, ToastModule],
  providers: [MessageService],
  template: `<pb-dashboard
    #dashboard
    [config]="dashboardConfig"
  ></pb-dashboard>`,
})
export class HomeComponent implements OnInit {
  @ViewChild('dashboard') dashboard!: DashboardComponent;

  dashboardConfig: DashboardConfig = {
    header: 'Organization Dashboard',
    subheader: 'Key Metrics Overview',
    refreshInterval: 300000, // Refresh every 5 minutes
    items: [],
    customToolbarItems: [
      {
        label: 'Members',
        icon: 'pi pi-users',
        onClick: () => this.router.navigate(['/contacts-dashboard']),
      },
      {
        label: 'Events',
        icon: 'pi pi-calendar',
        onClick: () => this.router.navigate(['/events-weekly']),
      },
    ],
  };

  constructor(
    private router: Router,
    private messageService: MessageService,
    private settingsService: SettingsService
  ) {}

  ngOnInit() {
    // Update dashboard config with dynamic names
    this.updateDashboardConfig();

    // Subscribe to naming settings changes
    this.settingsService.namingSettings$.subscribe(() => {
      this.updateDashboardConfig();
    });
  }

  private updateDashboardConfig() {
    const namingSettings = this.settingsService.getNamingSettings();

    // Update contact card
    if (
      this.dashboardConfig.items[0].data &&
      'title' in this.dashboardConfig.items[0].data
    ) {
      this.dashboardConfig.items[0].data.title =
        namingSettings.contactPluralName;
      if ('subtitle' in this.dashboardConfig.items[0].data) {
        this.dashboardConfig.items[0].data.subtitle = `Total ${namingSettings.contactSingleName.toLowerCase()}s`;
      }
    }

    // Update event card
    if (
      this.dashboardConfig.items[1].data &&
      'title' in this.dashboardConfig.items[1].data
    ) {
      this.dashboardConfig.items[1].data.title = namingSettings.eventPluralName;
      if ('subtitle' in this.dashboardConfig.items[1].data) {
        this.dashboardConfig.items[1].data.subtitle = `Total ${namingSettings.eventSingleName.toLowerCase()}s`;
      }
    }

    // Update custom toolbar items
    if (
      this.dashboardConfig.customToolbarItems &&
      this.dashboardConfig.customToolbarItems.length > 0
    ) {
      this.dashboardConfig.customToolbarItems[0].label = `${namingSettings.contactPluralName}`;
      if (this.dashboardConfig.customToolbarItems.length > 1) {
        this.dashboardConfig.customToolbarItems[1].label = `${namingSettings.eventPluralName}`;
      }
    }
  }
}
